module.exports = __webpack_public_path__ + "img/Mask Group 87.4f8552cf.png";